import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import store from '../store/index'
import { getToken } from '@/utils/auth'
import { Message } from 'element-ui'
import Cookies from 'js-cookie'
// 路由懒加载  但是测试环境还是用正常加载  懒加载会导致webpack热更新比较慢
const _import = require('./_import_' + process.env.NODE_ENV)
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 页面路由
/**
 * meta
 *  main 主要的模块对象键的值
 *  collapse 切换时的路由名字

 *  */
// 控制路由
const routerList = {
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'homePage',
      component: _import('main'),
      redirect: '/home/index',
      meta: {
        title: ''
      },
      children: [
        {
          path: 'index',
          name: 'home',
          component: _import('home/index'), meta: {
            main: 'home'
          }
        },
        {
          path: 'therapy',
          name: 'therapy',
          component: _import('therapy/index'),
          redirect: {
            path: '/home/therapy/therapyDetail',
            query: { menu: '经动脉化疗栓塞', first: 'HCC', second: '概述' }
          },
          children: [
            {
              path: 'therapyDetail',
              name: 'therapyDetail',
              component: _import('therapy/detail'),
              meta: {
                main: 'therapy',
                collapse: 'therapyDetail'
              }
            },
            {
              path: 'therapyDocument',
              name: 'therapyDocument',
              component: _import('therapy/periodical'),
              meta: {
                main: 'therapy',
                collapse: 'therapyDetail'
              }
            }
          ]
        },
        {
          path: 'interventionalVoice',
          name: 'interventionalVoice',
          component: _import('interventionalVoice/index'),
          redirect: {
            path: '/home/interventionalVoice/list',
            query: { menu: '介入医声' }
          },
          children: [
            {
              path: 'list',
              name: 'interventionalVoiceList',
              component: _import('interventionalVoice/detail'),
              meta: {
                main: 'interventionalVoice',
                collapse: 'list'
              }
            },
            {
              path: 'detail',
              name: 'interventionalVoiceDetail',
              component: _import('interventionalVoice/pageDetail'),
              meta: {
                main: 'interventionalVoice',
                collapse: 'detail'
              }
            }
          ]
        },
        {
          path: 'centre',
          name: 'centre',
          component: _import('centre/index'),
          redirect: {
            path: '/home/centre/item',
            query: { menu: '内容中心' }
          },
          children: [
            {
              path: 'item',
              name: 'centreItem',
              component: _import('centre/item'),
              meta: {
                main: 'centre',
                collapse: 'centreItem'
              }
            },
            {
              path: 'detail',
              name: 'centreDetail',
              component: _import('centre/detail'),
              meta: {
                main: 'centre',
                collapse: 'centreItem'
              }
            }
          ]
        },
        {
          path: 'patientEducation',
          name: 'patientEducation',
          component: _import('patientEducation/index'),
          redirect: {
            path: '/home/patientEducation/patientEducationDetail',
            query: { menu: '患者教育', first: '肾细胞癌肝细胞癌&结直肠癌肝转移' }
          },
          children: [
            {
              path: 'patientEducationDetail',
              name: 'patientEducationDetail',
              component: _import('patientEducation/detail'),
              meta: {
                main: 'patientEducation',
                collapse: 'patientEducationDetail'
              }
            }
          ]
        }
      ]
    },
    {
      path: '/404',
      component: _import('404/index')
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
}
function passport(to) {
  if (to.meta.passport) {
    return true
  }
  Message.closeAll()
  var param = window.location.href.substring(window.location.href.indexOf('#') + 1)
  if (param.includes('access_token')) {
    console.log('yes')
    const token = param.split('access_token=')[1].split('&')[0]
    console.log('token', token)
    if (token != '') return true
  }
  param = param.split('access_token')[0]
  param = param.replace('//', '/')
  Cookies.set('redirect_url', param)
  const url = 'https://passport.bscwin.com/AuthUser/CheckUser?client_id=35&redirect_uri=http%3a%2f%2fio.bostonscientific.cn%2fredirect.html'
  console.log(to.meta.main)
  const first = store.getters.pageData['mainMenu'][to.meta.main]['menu'] === undefined ? store.getters.pageData['mainMenu'][to.meta.main]['first'] : store.getters.pageData['mainMenu'][to.meta.main]['menu'][to.query.menu]['first']
  if (first['permission']) {
    if (first['permission']['disabled']) {
      return false
    } else if (first['permission']['auth']) {
      if (getToken() === 'undefined' || getToken() === '' || !Cookies.get('userinfo')) {
        window.location.href = url
        return false
      }
    }
  }
  const second = to.query.first ? first[to.query.first] : null
  if (second && second['permission']) {
    if (second['permission']['disabled']) {
      return false
    } else if (second['permission']['auth']) {
      if (getToken() === 'undefined' || getToken() === '' || !Cookies.get('userinfo')) {
        window.location.href = url
        return false
      }
    }
  }
  const detail = second ? (to.query.detail ? second : second['second'][to.query.second]) : null
  if (detail && detail['permission']) {
    if (detail['permission']['disabled']) {
      return false
    } else if (detail['permission']['auth']) {
      console.log(getToken())
      if (getToken() === 'undefined' || getToken() === '' || !Cookies.get('userinfo')) {
        window.location.href = url
        return false
      }
    }
  }
  return true
}
const router = new Router(routerList)
router.beforeEach((to, from, next) => {
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  if (Object.keys(store.getters.pageData).length) {
    if (passport(to)) next()
  } else {
    axios.get('./static/data.json').then(res => {
      store.commit('setPageData', res.data)
      if (passport(to)) next()
    })
  }
})
// router.beforeEach((to, form, next) => {
//   //   if (!getToken()) {
//   //     login().then(res => {
//   //       setToken(res.data.token)
//   //       next()
//   //     })
//   //   } else {
//   next()
//   //   }
// })
export default router
// export { pageList }



// WEBPACK FOOTER //
// ./src/router/index.js